import React from 'react';
import { useTranslation } from '../../../../../contexts/translation-context';
import { classes } from './indicators.st.css';
export const Indicators = ()=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        "aria-label": t('form.appointment.accessibility.calendar.has-availability.aria-label'),
        className: classes.root
    }, /*#__PURE__*/ React.createElement("div", {
        className: classes.indicator
    }));
};

//# sourceMappingURL=index.js.map